import React, { useEffect } from "react";
import ScrollToTop from "../../../components/whatsapp connect";
import "./About.css";
import styled from "styled-components";
import Marquee from "react-fast-marquee";
function AboutUsNew() {
  useEffect(() => {
    // Scroll to the top of the page whenever a new page is rendered
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <main>
        <ScrollToTop />
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a
                href="/"
                className="breadcrumb-item d-inline-block"
                title="Home"
              >
                {" "}
                Home{" "}
              </a>
              <span></span>
              <div className="breadcrumb-item d-inline-block active">
                {" "}
                About Us
              </div>
            </div>
          </div>
        </div>
        <PageWrapper>
          <HeroSection>
            <HeroContent>
              <HeroBadge>KeralaSpecial.in</HeroBadge>
              <HeroTitle>About Us</HeroTitle>
              <HeroSubtitle>Welcome to Keralaspecial.in</HeroSubtitle>
              <Paragraph>
                Kerala, fondly known as "God's Own Country," is a land of
                breathtaking beauty, vibrant traditions, and rich cultural
                heritage. From its tranquil beaches to its lush greenery and
                exquisite craftsmanship, Kerala offers an unforgettable
                experience that lingers in the heart.
              </Paragraph>
              <Paragraph>
                At KeralaSpecial.in, we bridge this gap, bringing the true
                essence of Kerala straight to your doorstep.
              </Paragraph>
              <HighlightGrid>
                <HighlightCard>
                  <HighlightTitle>Curated Treasures</HighlightTitle>
                  <Paragraph>
                    Our dedicated team of artists, academics, and industry
                    experts meticulously handpicks the finest products Kerala
                    has to offer. From intricate traditional handicrafts to
                    authentic Ayurvedic wellness products, we ensure every item
                    tells a story of heritage and excellence.
                  </Paragraph>
                </HighlightCard>
                <HighlightCard>
                  <HighlightTitle>Empowering Local Artisans</HighlightTitle>
                  <Paragraph>
                    Each purchase you make helps sustain Kerala's skilled
                    artisans, weavers, and craftsmen. By supporting their work,
                    you contribute to preserving centuries-old traditions and
                    uplifting local communities.
                  </Paragraph>
                </HighlightCard>
                <HighlightCard>
                  <HighlightTitle>Uncompromising Quality</HighlightTitle>
                  <Paragraph>
                    Every product undergoes stringent quality checks, ensuring
                    that you receive only the best Kerala has to offer.
                  </Paragraph>
                </HighlightCard>
              </HighlightGrid>
            </HeroContent>
            <HeroVisual>
              <HeroImage
                src="/storage/general/about.png"
                alt="KeralaSpecial.in team"
              />
              <HeroOverlayCard>
                <OverlayTitle>Experience Kerala</OverlayTitle>
                <OverlaySubtitle>Enchantment delivered to your home</OverlaySubtitle>
              </HeroOverlayCard>
            </HeroVisual>
          </HeroSection>

          <StorySection>
            <SectionTitle>Experience Kerala: Enchantment Delivered</SectionTitle>
            <SectionGrid>
              <StoryCard>
                <Paragraph>
                  Kerala offers an unforgettable experience. From its serene
                  beaches to its vibrant culture, Kerala leaves a lasting
                  impression. But recreating that magic can be difficult.
                </Paragraph>
                <Paragraph>
                  At KeralaSpecial.in, we bridge the gap. We bring the essence
                  of Kerala straight to your doorstep.
                </Paragraph>
              </StoryCard>
              <JourneyCard>
                <JourneySubtitle>Start your journey with us</JourneySubtitle>
                <LightParagraph>
                  Whether you're looking for a piece of Kerala to brighten your
                  home, a meaningful gift for a loved one, or an authentic
                  connection to this enchanting land, KeralaSpecial.in is your
                  trusted partner in celebrating the spirit of "God's Own
                  Country."
                </LightParagraph>
                <LightParagraph>
                  Start your journey with us and bring a touch of Kerala’s magic
                  into your life today!
                </LightParagraph>
              </JourneyCard>
            </SectionGrid>
          </StorySection>

          <LaunchSection>
            <SectionTitle>The Grand Launch Event</SectionTitle>
            <LaunchGrid>
              <LaunchContent>
                <Paragraph>
                  KeralaSpecial.in was inaugurated with great enthusiasm and
                  grandeur by the eminent Shri Kanayi Kunhiraman, a celebrated
                  sculptor and an ardent advocate for Kerala’s rich cultural
                  heritage. In his inaugural address, Shri Kanayi shared his
                  heartfelt vision for KeralaSpecial.in, aspiring for it to
                  become a dynamic online platform that celebrates and preserves
                  Kerala's exquisite arts, crafts, and traditions.
                </Paragraph>
                <SectionSubtitle>A gathering of luminaries</SectionSubtitle>
                <Paragraph>
                  The event was graced by some of Kerala’s most distinguished
                  personalities, who lent their support and encouragement to
                  this ambitious endeavor. Leading the dignitaries was Shri
                  Kanayi Kunhiraman, whose passion for culture and art deeply
                  resonates with KeralaSpecial.in's mission.
                </Paragraph>
              </LaunchContent>
              <LaunchVisual>
                <LaunchImage
                  src="/storage/general/about2.png"
                  alt="KeralaSpecial.in launch event"
                />
              </LaunchVisual>
            </LaunchGrid>
            <SectionSubtitle>Also in attendance were</SectionSubtitle>
            <Paragraph>
              <b>Dr. P. K. Madhavan Nair,</b> former member of the Kerala Public
              Service Commission, who brought his wisdom and experience to the
              occasion.
              <br />
              <br />
              <b>Shri P. K. Venugopal,</b> former Chairman of the Trivandrum
              Development Authority, whose leadership in development and
              governance inspired the initiative’s forward-looking vision.
            </Paragraph>
            <SectionSubtitle>Guided by visionary leaders</SectionSubtitle>
            <Paragraph>
              The launch was further illuminated by the presence of
              KeralaSpecial.in’s visionary directors:
              <br />
              <br />
              <b>Dr. Vijayakumaran Nair,</b> a seasoned academic and strategist.
              <br />
              <br />
              <b>Dr. N K Mohan Das,</b> whose passion and expertise drive the
              venture forward.
              <br />
              <br />
              <b>Mr. Shiju Lukose,</b> a technology expert committed to building
              a robust digital presence for KeralaSpecial.in.
              <br />
              <br />
              Their collective leadership and unwavering commitment are pivotal
              to KeralaSpecial.in’s journey of bringing the magic of Kerala to a
              global audience.
            </Paragraph>
          </LaunchSection>

          <FeaturedSection>
            <SectionTitle>Featured In</SectionTitle>
            <MarqueeContainer>
              <Marquee pauseOnHover={true}>
                <IconContainer>
                  <img src="/storage/general/featured1.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured2.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured3.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured4.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured5.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured1.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured2.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured3.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured4.png" alt="featured-in" />
                </IconContainer>
                <IconContainer>
                  <img src="/storage/general/featured5.png" alt="featured-in" />
                </IconContainer>
              </Marquee>
            </MarqueeContainer>
          </FeaturedSection>

          <EssenceSection>
            <SectionTitle>Discover the Essence of Kerala with KeralaSpecial.in</SectionTitle>
            <Paragraph>
              Kerala offers an experience like no other. At KeralaSpecial.in, we
              bring the spirit of Kerala closer to you. Whether you're near or
              far, we ensure that the authentic charm of this enchanting land
              reaches your doorstep.
            </Paragraph>
            <SectionSubtitle>Why choose KeralaSpecial.in?</SectionSubtitle>
            <EssenceGrid>
              <EssenceCard>
                <HighlightTitle>Unearth Exquisite Products</HighlightTitle>
                <Paragraph>
                  Our passionate team, comprising artists, academics, and
                  industry experts, meticulously curates the very best Kerala
                  has to offer. From timeless traditional handicrafts to
                  holistic Ayurvedic products, every item reflects the soul of
                  Kerala’s rich cultural heritage.
                </Paragraph>
              </EssenceCard>
              <EssenceCard>
                <HighlightTitle>Support Local Artisans</HighlightTitle>
                <Paragraph>
                  Every purchase you make contributes to preserving Kerala’s
                  age-old traditions. By supporting talented artisans, weavers,
                  and craftsmen, you’re empowering local communities and helping
                  to sustain their livelihoods for generations to come.
                </Paragraph>
              </EssenceCard>
              <EssenceCard>
                <HighlightTitle>Experience Unmatched Quality</HighlightTitle>
                <Paragraph>
                  At KeralaSpecial.in, quality is our promise. Each product
                  undergoes rigorous checks to ensure it meets the highest
                  standards, delivering authenticity and excellence to your
                  home. With KeralaSpecial.in, you’re not just shopping—you’re
                  embracing the heritage, artistry, and spirit of Kerala.
                </Paragraph>
              </EssenceCard>
            </EssenceGrid>
          </EssenceSection>
        </PageWrapper>
      </main>
    </>
  );
}

export default AboutUsNew;
const PageWrapper = styled.div`
  max-width: 90vw;
  margin: 0 auto;
  padding: 0 24px 96px;
`;

const HeroSection = styled.section`
  margin-top: 64px;
  background: linear-gradient(135deg, #fff7ea 0%, #ffffff 60%);
  border-radius: 32px;
  padding: 48px 56px;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 40px;
  align-items: center;
  box-shadow: 0 40px 80px rgba(16, 24, 40, 0.08);

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    padding: 40px 32px;
  }

  @media screen and (max-width: 640px) {
    padding: 32px 24px;
    margin-top: 40px;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HeroBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(98, 188, 1, 0.15);
  color: #2f6f26;
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  font-size: 12px;
  width: fit-content;
`;

const HeroTitle = styled.h1`
  font-size: 48px;
  line-height: 1.1;
  margin: 0;
  color: #111827;

  @media screen and (max-width: 768px) {
    font-size: 36px;
  }
`;

const HeroSubtitle = styled.h3`
  margin: 0;
  font-size: 20px;
  color: #62bc01;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

const Paragraph = styled.p`
  margin: 0;
  color: #374151;
  line-height: 1.7;
  font-size: 16px;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
`;

const HighlightGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-top: 16px;

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const HighlightCard = styled.div`
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
  }
`;

const HighlightTitle = styled.h4`
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
`;

const HeroVisual = styled.div`
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background: #111827;
  min-height: 360px;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const HeroOverlayCard = styled.div`
  position: absolute;
  bottom: 24px;
  left: 24px;
  right: 24px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 20px;
  padding: 18px 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.25);
  backdrop-filter: blur(6px);
`;

const OverlayTitle = styled.h5`
  margin: 0;
  font-size: 16px;
  color: #111827;
  font-weight: 600;
`;

const OverlaySubtitle = styled.p`
  margin: 4px 0 0;
  color: #4b5563;
  font-size: 14px;
`;

const StorySection = styled.section`
  margin-top: 96px;
`;

const SectionTitle = styled.h2`
  margin: 0 0 32px;
  font-size: 32px;
  font-weight: 600;
  text-transform: uppercase;
  color: #0f172a;
  letter-spacing: 1.2px;

  @media screen and (max-width: 768px) {
    font-size: 26px;
  }
`;

const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 28px;

  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const StoryCard = styled.div`
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const JourneyCard = styled.div`
  background: linear-gradient(135deg, #62bc01 0%, #3a7d16 100%);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SectionSubtitle = styled.h5`
  margin: 24px 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  text-transform: capitalize;
`;

const JourneySubtitle = styled(SectionSubtitle)`
  margin-top: 0;
  color: #f9fafb;
`;

const LightParagraph = styled(Paragraph)`
  color: #f9fafb;
  opacity: 0.92;
`;

const LaunchSection = styled.section`
  margin-top: 96px;
  padding: 64px 48px;
  background: #f4f9ed;
  border-radius: 32px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);

  @media screen and (max-width: 768px) {
    padding: 40px 28px;
  }
`;

const LaunchGrid = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 32px;
  align-items: center;

  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const LaunchContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const LaunchVisual = styled.div`
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.15);
  background: #111827;
`;

const LaunchImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FeaturedSection = styled.section`
  margin-top: 96px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const MarqueeContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 18px 12px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
`;

const IconContainer = styled.div`
  height: 120px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  img {
    max-height: 100%;
    width: auto;
    object-fit: contain;
    filter: grayscale(15%);
    opacity: 0.9;
  }
`;

const EssenceSection = styled.section`
  margin-top: 96px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const EssenceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const EssenceCard = styled.div`
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
